export default {
  'Cases types': '盒子類型',
  'Possible contents of the case': '盒子的可能內容物',
  'Other cases': '其他盒子',
  'Open for': '為...打開',
};
